import {
  assignUserLocation,
  getAdminUsers,
  getAdminUser,
  postAdminUser,
  putAdminUser
} from '../api'

export const fetchAdminUsers = async (paginate) => {
  const req = await getAdminUsers(paginate)
  return { type: 'GET_ADMIN_USERS_SUCCESS', data: req.users }
}

export const fetchAdminUser = async (slug) => {
  const req = await getAdminUser(slug)
  return { type: 'GET_ADMIN_USER_SUCCESS', data: req.user }
}

export const editAdminUser = async (payload) => {
  const req = await putAdminUser(payload)
  return { type: 'GET_ADMIN_USER_SUCCESS', data: req.user }
}

export const createAdminUser = async (payload) => {
  const req = await postAdminUser(payload)
  return { type: 'CREATE_ADMIN_USER_SUCCESS', data: req.user }
}

export const addLocationToUser = async (payload) => {
  const req = await assignUserLocation(payload)
  return { type: 'ASSIGN_USER_LOCATION_SUCCESS', data: req }
}
